import {
  SET_PRICECALC_PRICES,
  OPEN_POPUP_PARTS,
  SET_CAR_PARTS,
  SET_CAR_PRICEPARTS,
  SET_CAR_SELECTED_PARTS,
  SET_CAR_ITEMS
} from '../constants'

const initialState = {
  price: {},
  showPopupForParts: false,
  carParts: [],
  carPriceParts: [],
  carSelectedParts: []
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PRICECALC_PRICES:
      return {
        ...state,
        price: action.price
      }
    case OPEN_POPUP_PARTS:
      return {
        ...state,
        showPopupForParts: action.showPopupForParts,
        selectedBodyPart: action.selectedBodyPart,
        selectedBodyPartSide: action.selectedBodyPartSide
      }
    case SET_CAR_PARTS:
      return {
        ...state,
        carParts: action.carParts
      }
    case SET_CAR_PRICEPARTS:
      return {
        ...state,
        carPriceParts: action.carPriceParts
      }
    case SET_CAR_SELECTED_PARTS:
      return {
        ...state,
        carSelectedParts: action.carSelectedParts
      }
    case SET_CAR_ITEMS:
      return {
        ...state,
        carItems: action.carItems
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/price.js